/* eslint-disable  @typescript-eslint/no-explicit-any */

import React from 'react';
import { useAppSelector } from '../../app/hooks';
import { hr } from '../../assets/images/login';
import { useGetToken } from '../../hooks/useGetToken';
import Button from './Button';

type TProps = {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  showPhoneOtpModal: () => void;
  closeEmailOtpModal: () => void;
};
export default function UnVerifiedPhoneModal({
  showModal,
  setShowModal,
  showPhoneOtpModal,
}: TProps) {
  const tokenForPhoneOtp = localStorage.getItem('token-for-phone-otp');

  // ---- GET PHONE OTP HOOK ---- //
  const onGetTokenSuccessFul = () => {
    setShowModal(false);
    showPhoneOtpModal();
  };
  const { getTokenApi, loading, otpType } = useGetToken({
    onGetTokenSuccess: onGetTokenSuccessFul,
  });
  const { userName, phoneNumber } = useAppSelector((state) => state.auth.loggedInUserDetails);

  const handleGetToken = () => {
    !loading && getTokenApi(tokenForPhoneOtp);
  };
  return (
    <>
      {showModal ? (
        <>
          <div className='fixed inset-0 z-[100000] overflow-y-auto'>
            <div
              className='fixed inset-0 w-full h-full bg-black opacity-40'
              onClick={() => setShowModal(false)}
            ></div>
            <div className='flex items-center min-h-screen px-6 py-4'>
              <div className='relative p-[1.6em] sm:py-8 sm:px-[5rem] mx-auto bg-white rounded-md shadow-lg'>
                <div className='sm:mt-[1.5em] max-w-[300px] sm:flex justify-center'>
                  <div className=' text-center sm:text-left'>
                    <p className=' text-[#229698] text-[18.6356px] font-[600] font-["Poppins"] leading-[28px]'>
                      Dear {` `} {userName}
                    </p>
                    <div className='flex justify-center'>
                      <p className='mt-2 text-[12px] leading-[18px] font-[400] mb-1 w-[95%]'>
                        {`Your phone number`} {` `}
                        <br />
                        <span className='text-[#229698] font-bold'>{phoneNumber}</span>
                        {` `}
                        {`has not been verified,`}
                        {` `}
                        kindly click on the button below to get a verification otp.
                      </p>
                    </div>

                    <div className='flex justify-center mt-2'>
                      <Button loading={loading} onClick={() => handleGetToken()}>
                        Get OTP
                      </Button>
                    </div>

                    <div className='mb-3'>
                      <img src={hr} alt='hr.png' />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
}
